import { createSlice } from "@reduxjs/toolkit";
import { fetchDailyTransactions, startOperation, endOperation, absentOperation } from "./ptThunks";

const initialState = {
  list: [],
  loading: false,
  error: null,
};

const ptSlice = createSlice({
  name: "participationTransactions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // FETCH
    builder.addCase(fetchDailyTransactions.pending, (state) => { state.loading = true; state.error = null; });
    builder.addCase(fetchDailyTransactions.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload || [];
    });
    builder.addCase(fetchDailyTransactions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // START
    builder.addCase(startOperation.pending, (state) => { state.loading = true; state.error = null; });
    builder.addCase(startOperation.fulfilled, (state, action) => {
      state.loading = false;
      const { employeeId, startTime, transaction } = action.payload;
      const item = state.list.find((x) => x.id === employeeId);
      if (item) {
        item.transaction = {
          id: transaction?.id || "temp",
          startTime,
          endTime: null,
          absentAt: null,
          description: null,
          reasonType: 0
        };
      }
    });
    builder.addCase(startOperation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // END
    builder.addCase(endOperation.pending, (state) => { state.loading = true; state.error = null; });
    builder.addCase(endOperation.fulfilled, (state, action) => {
      state.loading = false;
      const { employeeId, endTime } = action.payload;
      const item = state.list.find((x) => x.id === employeeId);
      if (item && item.transaction) {
        item.transaction.endTime = endTime;
      }
    });
    builder.addCase(endOperation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // ABSENT
    builder.addCase(absentOperation.pending, (state) => { state.loading = true; state.error = null; });
    builder.addCase(absentOperation.fulfilled, (state, action) => {
      state.loading = false;
      const { employeeId, absentAt, description, reasonType } = action.payload;
      const item = state.list.find((x) => x.id === employeeId);
      if (item) {
        item.transaction = {
          id: "temp",
          startTime: null,
          endTime: null,
          absentAt,
          description,
          reasonType
        };
      }
    });
    builder.addCase(absentOperation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

export default ptSlice.reducer;
